export const MENTOR_TOKEN_REFRESHED = "MENTOR_TOKEN_REFRESHED";
export const MENTOR_TOKEN_REFRESH_NEEDED = "MENTOR_TOKEN_REFRESH_NEEDED";
export const MENTOR_TOKEN_EXPIRED = "MENTOR_TOKEN_EXPIRED";
export const API_ERROR_OCCURRED = "API_ERROR_OCCURRED";
// By convention, actions that end in "_SUCCESS" are assumed to have been the result of a completed api call and will decrement the apiCallsInProgress count
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";